export default __webpack_public_path__ + "static/media/logo.24269d9a.png";